import App from './App';

export default App;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/index.ts